/**
 * Mobile Hero Slideshow — Nameg
 * Auto-rotates 16 hero images every 4 seconds with crossfade.
 * Runs on mobile and tablet viewports (<=1366px).
 */
(function() {
  'use strict';

  var INTERVAL = 4000;
  var MOBILE_MQ = '(max-width: 1366px)';

  var container = document.querySelector('[data-mobile-hero-slideshow]');
  if (!container) return;

  var slides = container.querySelectorAll('.nameg-hero-mobile-slide');
  if (slides.length < 2) return;

  var current = 0;
  var timer = null;
  var mql = window.matchMedia(MOBILE_MQ);

  // Lazy-load: swap data-bg → background-image
  function ensureLoaded(slide) {
    var bg = slide.getAttribute('data-bg');
    if (bg) {
      slide.style.backgroundImage = 'url(' + bg + ')';
      slide.removeAttribute('data-bg');
    }
  }

  function nextSlide() {
    var next = (current + 1) % slides.length;
    // Preload the next image before showing it
    ensureLoaded(slides[next]);
    slides[current].classList.remove('active');
    slides[next].classList.add('active');
    current = next;
    // Preload the one after next for seamless transitions
    var preloadIdx = (next + 1) % slides.length;
    ensureLoaded(slides[preloadIdx]);
  }

  function start() {
    if (!timer && mql.matches) {
      timer = setInterval(nextSlide, INTERVAL);
    }
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  // Pause when tab is hidden
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  // Only run on mobile
  function handleViewport(e) {
    if (e.matches) {
      start();
    } else {
      stop();
    }
  }

  // Use addEventListener if available (modern), else addListener (Safari <14)
  if (mql.addEventListener) {
    mql.addEventListener('change', handleViewport);
  } else if (mql.addListener) {
    mql.addListener(handleViewport);
  }

  // Initial start
  if (mql.matches) {
    // Preload second image for smooth first transition
    ensureLoaded(slides[1]);
    start();
  }
})();
